import React, { useState } from "react";
import Title from "../title/Title";
import ResumeCard from "./ResumeCard";
import { motion } from "framer-motion";
const Certificates = ({ companiesData, courseraData }) => {
  const [visible, setVisible] = useState(2);

  const showMoreItems = () => {
    setVisible((preValue) => preValue + 2);
  };
  return (
    <motion.div
      initial={{ y: "100%", opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="w-full"
    >
      <div className="w-full grid lg:grid-cols-2 gap-16">
        {/* Coursera */}
        <div>
          <Title
            title="2021 - present"
            desc="university"
            fontSize="text-2xl md:text-4xl"
          />
          <div className="w-full border-l-[6px] border-l-black border-opacity-30 flex flex-col space-y-10">
            {courseraData.slice(0, visible).map((item) => (
              <ResumeCard item={item} key={item.id} />
            ))}
          </div>
        </div>
        {/* Companies */}
        <div>
          <Title
            title="2021 - present"
            desc="company"
            fontSize="text-2xl md:text-4xl"
          />
          <div className="w-full border-l-[6px] border-l-black border-opacity-30 flex flex-col space-y-10">
            {companiesData.slice(0, visible).map((item) => (
              <ResumeCard item={item} key={item.id} />
            ))}
          </div>
        </div>
      </div>
      {visible < companiesData.length && courseraData.length && (
        <div className="mt-8">
          <button className="btn w-full md:w-auto" onClick={showMoreItems}>
            View More
          </button>
        </div>
      )}
    </motion.div>
  );
};

export default Certificates;
